<template>
     <!-- 出发地 -->
    <div class="departure-search-form search-form-container" :class="{'f-dn': !isShow}" data-key="DepartureCode">
        <div class="line" v-if="cruiseType == 'row'"></div>
        <div v-else class="f-dn"></div>
        <div class="departure-area search-form-item" v-for="(departureGroup, index) in departureGroups" :key="index" :style="departureListStyle(index)">
            <span class="departure-area-name search-form-title" v-if="departureGroups.length > 1">{{departureGroup}}</span>
            <span v-else></span>
            <div class="departure-area-list search-form-list">
                <div class="departure-area-item search-form-list-item search-form-list-item-all"
                    data-cnvalue="全部" 
                    data-filtercode="全部" 
                    data-key="DepartureCode" data-cruise="hp"
                    :v-if="getDepartureByGroup(departureGroup).length > 1"
                    :class="{ active: isSelectedAll(departureGroup), disable: isDisableAll(departureGroup) }"
                    @click="onDepartureAllClick(departureGroup)"
                    >
                    <div class="search-form-list-item-nochecked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox.png" />
                    </div>
                    <div class="search-form-list-item-checked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox-selected.png" />
                    </div>
                    <span class="search-form-list-item-text" data-toggle="tooltip" data-placement="right" :data-title="hpDepartureTips">全部出发港</span>
                </div>
                <div class="departure-area-item search-form-list-item"
                    v-for="(hpDeparture, index) in getDepartureByGroup(departureGroup)" :key="index"
                    :data-cnvalue="getDepartureTitle(hpDeparture.title)" 
                    :data-filtercode="hpDeparture.filterCode"
                    :class="{ active: isSelected(hpDeparture.filterCode), disable: isDisable(hpDeparture.filterCode)}"
                    data-key="DepartureCode" 
                    @click="onDepartureClick(hpDeparture)"
                    data-cruise="hp">
                    <div class="search-form-list-item-nochecked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox.png" />
                    </div>
                    <div class="search-form-list-item-checked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox-selected.png" />
                    </div>
                    <span class="search-form-list-item-text" data-toggle="tooltip" data-placement="right" :data-title="hpDepartureTips">{{getDepartureTitle(hpDeparture.title)}}</span>
                    <div class="flag-content">
                        <img class="flag" :src="hpDeparture.countryFlag" />
                        <span class="flag-text">{{hpDeparture.countryName}}</span>
                    </div>
                </div>

                
            </div>
        </div>
        <div class="search-form-clear" @click="onClearClick()">
            <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-clear.png" />
            <span>清空全部</span>
        </div>

        <div class="go-to-cruise-port" v-if="cruiseType == 'row'">
            <a :href="toRowPage" target="_blank">
                <img src="https://resource.rcclchina.com.cn/cruiseSearch/to-cruise-port.gif" />
            </a>
        </div>
        <div v-else class="f-dn"></div>

    </div>

</template>

<script>
export default {
    name: 'DepartureForm',
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        isShow: {
            type: Boolean,
            default: function() {
                return false
            }
        },
        departures: {
            type: Array,
            default: function() {
                return []
            }
        },
        departureGroups: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    data () {
        return {
            cruiseNotAllowTips: "<div><img src='https://resource.rcclchina.com.cn/partner/search-bar-tips.png' /></div>",
            selectDepartures: [],
            selectAllDepartureGroups: [],
            toRowPage: process.env.VUE_APP_BASE_URL+'/campaign/ROWDestination/Cruise/CruisePortIndex',
        }
    },
    methods: {
        departureListStyle (index) {
            return (this.departureGroups.length > 1 && index == 0) ? { 'margin-left': '20px'} : {}
        },
        getDepartureByGroup (departureGroup) {
            return this.departures.filter(item => item.cruiseFilterGroupName == departureGroup)
        },
        getDepartureTitle (departureTitle) {
            return departureTitle.split('(')[0]
        },
        onDepartureClick (departure) {
            let code = departure.filterCode
            if (this.isDisable(code)) {
                return
            }
            let name = this.getDepartureTitle(departure.title)
            let group = departure.cruiseFilterGroupName
            let isExists = this.selectDepartures.some(item=> item.code == code)
            const cruiseType = this.cruiseType
            const data = { 
                cruiseType,
                key: 'departures',
                values: [{ code, name }]
            }
            if (isExists) {
                this.selectDepartures = this.selectDepartures.filter(item => !(item.code == code))
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)

                if (this.isSelectedAll(group)) {
                    this.selectAllDepartureGroups = this.selectAllDepartureGroups.filter(item=>!(item == group))
                }

            } else {
                this.selectDepartures.push({ code, name, group })
                this.$store.dispatch('SET_CRUISE_FILTERS', data)

                // 全选逻辑
                if (this.checkDepartureAllSelected(group)) {
                    if (!this.isSelectedAll(group)) {
                        this.selectAllDepartureGroups.push(group)
                    }
                }
            }
        },
        onDepartureAllClick (departureGroup) {
            const cruiseType = this.cruiseType
            // 反选
            if (this.isSelectedAll(departureGroup)) {
                this.selectAllDepartureGroups = this.selectAllDepartureGroups.filter(item=>!(item == departureGroup))
                // 删除该group下所有选择
                const needRemoveDeps = this.selectDepartures.filter(item => item.group == departureGroup)
                this.selectDepartures = this.selectDepartures.filter(item => !(item.group == departureGroup))
                const data = {
                    cruiseType,
                    key: 'departures',
                    values: needRemoveDeps
                }
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            } else {
                if (this.isDisableAll(departureGroup)) {
                    return
                }
                const departures = this.departures.filter(item=>item.cruiseFilterGroupName == departureGroup)
                let needAddDeps = []
                departures.forEach((departure) => {
                    if (!this.selectDepartures.some(item => item.code == departure.filterCode)) {
                        let code = departure.filterCode
                        if (!this.isDisable(code)) {
                            let name = this.getDepartureTitle(departure.title)
                            let group = departure.cruiseFilterGroupName
                            needAddDeps.push({ code, name, group })
                            this.selectDepartures.push({ code, name, group })
                        }
                    }
                })
                this.selectAllDepartureGroups.push(departureGroup)
                const data = {
                    cruiseType,
                    key: 'departures',
                    values: needAddDeps
                }
                this.$store.dispatch('SET_CRUISE_FILTERS', data)
            }
        },
        checkDepartureAllSelected (departureGroup) {
            let departures = this.getDepartureByGroup(departureGroup)
            let selectedCount = this.selectDepartures.filter(item => item.group == departureGroup).length
            return departures.length == selectedCount
        },
        isSelected (code) {
            return this.selectDepartures.some(item=> item.code == code)
        },
        isSelectedAll (departureGroup) {
            return this.selectAllDepartureGroups.includes(departureGroup)
        },
        onClearClick () {
            const data = {
                cruiseType: this.cruiseType,
                key: 'departures',
                values: this.selectDepartures
            }
            this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            this.selectDepartures = []
            this.selectAllDepartureGroups = []
        },
        isDisable (code) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].departures
            return !availableItems.includes(code)
        },
        isDisableAll (departureGroup) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].departures
            let departureCodes = this.getDepartureByGroup(departureGroup).map(item=>item.filterCode)
            return !availableItems.some(item=> departureCodes.includes(item))
        }
    },
    computed: {
        hpDepartureTips() {
            return this.cruiseNotAllowTips + "<div class='tip-text'><span>您目前选择的是海外出发港口，暂无法同时选择中国/日本出发港口哦</span></div>"
        },
        rowDepartureTips () {
            return this.cruiseNotAllowTips + "<div class='tip-text'><span>您目前选择的是中国/日本出发港口，暂无法同时选择海外出发港口哦</span></div>"
        }
    }
}
</script>
